document.addEventListener('DOMContentLoaded', function () {
    const fbtSpinner = document.querySelector('.buy-together .loading__spinner');
    const fbtPrice = document.getElementById('fbt-price');
    const includeBtn = document.querySelectorAll('.include-button');
    const formData = {
        'items': [],
        'sections': ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble', 'cart-drawer']
    };

    includeBtn.forEach(incBtn => {
        incBtn.addEventListener('click', () => {
            if (incBtn.checked) {
                addFormData(incBtn.dataset.product_id, incBtn.dataset.variant_id);
                updateFbtPrice(incBtn.dataset.price, 'add');
            } else {
                formData.items.splice(formData.items.findIndex((item) => item['product-id'] === incBtn.dataset.product_id), 1);
                updateFbtPrice(incBtn.dataset.price, '');
            }
        });
    });

    document.querySelector('.buy-together').addEventListener('click', (event) => {
        event.target.classList.add('loading');
        fbtSpinner.classList.remove('hidden');

        addFormData(event.target.dataset.product_id, event.target.dataset.variant_id);

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then((response) => response.json())
            .then((response) => {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    cartData: response,
                });
                (document.querySelector('cart-notification') || document.querySelector('cart-drawer')).renderContents(response);
                formData.items = []
                includeBtn.forEach(checkbox => {
                    if (checkbox.checked) updateFbtPrice(checkbox.dataset.price, '');
                    checkbox.checked = false;
                });
            }).
            catch((error) => {
                console.error('Error:', error);
            })
            .finally(() => {
                event.target.classList.remove('loading');
                fbtSpinner.classList.add('hidden');
            });
    })

    function updateFbtPrice(price, operation) {
        let totalPrice = Number(fbtPrice.dataset.price);
        price = Number(price);
        totalPrice += (operation === 'add') ? price : -price;
        fbtPrice.dataset.price = totalPrice.toString();
        fbtPrice.innerHTML = Shopify.formatMoney(totalPrice, Shopify.money_format) ;
    }

    function addFormData(productId, variantId) {
        formData.items.push({
            'product-id': productId,
            'quantity': 1,
            'id': variantId
        })
    }
});